import React from 'react';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import Button from '@atlaskit/button';

type NextBillDateWarningModalProps = {
  closeModal: () => void;
};

export const NextBillDateWarningModal: React.FC<NextBillDateWarningModalProps> = ({ closeModal }) => {
  return (
    <ModalTransition>
      <Modal
        onClose={closeModal}
        isBlanketHidden={false}
        width={'medium'}
        testId="uof.modal.next-bill-date-warning-modal"
      >
        <ModalHeader>
          <ModalTitle appearance="warning">Add all site's Jira subscriptions first</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <>
            <p>
              Jira products and apps on the same site need to be billed together, so they'll need to have the same new
              billing date. To select a new date, first add all of the site's Jira subscriptions.
            </p>
            <br />
            <p>Pro-rated adjustments will be applied to the next invoice.</p>
          </>
        </ModalBody>
        <ModalFooter>
          <Button appearance="subtle" onClick={closeModal}>
            Cancel
          </Button>
          <Button appearance="warning" onClick={closeModal} autoFocus>
            Ok, got it
          </Button>
        </ModalFooter>
      </Modal>
    </ModalTransition>
  );
};
